export default __webpack_public_path__ + "static/media/Default_pfp.b19663f6.webp";